module.exports = __webpack_public_path__ + "static/1_1_defineai_IS-cc60dc5fc30049f7524cfe7e7a43e8db.svg";